var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-splitter',{staticStyle:{"display":"flex","height":"100%","overflow":"hidden"},attrs:{"margin":30,"horizontal":_vm.horizontal}},[_c('groups',{attrs:{"slot":"left-pane"},on:{"choice":_vm.choice},slot:"left-pane"}),_c('group-config',{attrs:{"slot":"right-pane","group":_vm.cur_group,"clients":_vm.clients},slot:"right-pane"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }